<template>
  <div class="overlay" v-if="active">
    <div class="modal">
      <div class="layout">
        <div class="item">
          <a
            href="#"
            class="ctaButton navigation-icon close"
            v-on:click.prevent="active = false"
          ></a>
          <div class="wrapper">
            <slot></slot>

            <form
              action="javascript:"
              v-on:submit.prevent="submit"
              class="mt-5"
            >
              <div class="row">
                <div class="col-md-6">
                  <div class="group">
                    <input
                      type="text"
                      v-model="fields.honey"
                      class="honey-pot"
                    />
                    <div
                      class="g-recaptcha"
                      v-bind:data-callback="'recaptcha'"
                      v-bind:data-sitekey="'6LffqKIZAAAAAMrS6WHV81yXC8iS8rRaKhh7T_Pg'"
                      v-bind:data-size="'invisible'"
                    ></div>

                    <label>First name</label>
                    <input
                      type="text"
                      placeholder="John"
                      ref="firstname"
                      v-model="fields.firstname"
                      v-bind:class="{
                        'validation -invalid': validation.firstname,
                      }"
                    />
                    <div
                      v-if="validation.firstname"
                      v-on:click="setfocus('firstname')"
                      class="error-message"
                    >
                      {{ validation.firstname[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>Last name</label>
                    <input
                      type="text"
                      placeholder="Smith"
                      ref="lastname"
                      v-model="fields.lastname"
                      v-bind:class="{
                        'validation -invalid': validation.lastname,
                      }"
                    />
                    <div
                      v-if="validation.lastname"
                      v-on:click="setfocus('lastname')"
                      class="error-message"
                    >
                      {{ validation.lastname[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>Email</label>
                    <input
                      type="text"
                      placeholder="smith@example.com"
                      ref="email"
                      v-model="fields.email"
                      v-bind:class="{ 'validation -invalid': validation.email }"
                    />
                    <div
                      v-if="validation.email"
                      v-on:click="setfocus('email')"
                      class="error-message"
                    >
                      {{ validation.email[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>ResMed account number (if known)</label>
                    <input
                      type="text"
                      placeholder="123-456-12345"
                      v-model="fields.account"
                    />
                  </div>
                  <div class="group">
                    <label>Company name</label>
                    <input
                      type="text"
                      placeholder="Company"
                      ref="company"
                      v-model="fields.company"
                      v-bind:class="{
                        'validation -invalid': validation.company,
                      }"
                    />
                    <div
                      v-if="validation.company"
                      v-on:click="setfocus('company')"
                      class="error-message"
                    >
                      {{ validation.company[0] }}
                    </div>
                  </div>
                  <!-- <div class="group">
                                        <label>Store type</label>
                                        <input type="radio" id="radio-a" value="Physical" v-model="fields.storetype">
                                        <label for="radio-a" class="mr-3">Physical</label>

                                        <input type="radio" id="radio-b" value="Online" v-model="fields.storetype">
                                        <label for="radio-b" class="mr-3">Online</label>

                                        <input type="radio" id="radio-c" value="Both" v-model="fields.storetype">
                                        <label for="radio-c">Both</label>
                                    </div> -->
                </div>
                <div class="col-md-6">
                  <div class="group">
                    <label>Business type</label>
                    <select
                      v-model="fields.business"
                      ref="business"
                      v-on:change="
                        validation.business && (validation.business[0] = null)
                      "
                    >
                      <option disabled="disabled" value="">Select one</option>
                      <option>Hospital</option>
                      <option>HME</option>
                      <option>Sleep Clinic</option>
                      <option>Telehealth provider</option>
                      <option>Other</option>
                    </select>
                    <div v-if="validation.business" class="-validation">
                      {{ validation.business[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>Street Address</label>
                    <input
                      type="text"
                      placeholder="987 Wilsom Street"
                      ref="address"
                      v-model="fields.address"
                      v-bind:class="{
                        'validation -invalid': validation.address,
                      }"
                    />
                    <div
                      v-if="validation.address"
                      v-on:click="setfocus('address')"
                      class="error-message"
                    >
                      {{ validation.address[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>City/Town</label>
                    <input
                      type="text"
                      v-bind:placeholder="
                        country === 'US' ? 'San Diego' : 'Toronto'
                      "
                      ref="city"
                      v-model="fields.city"
                      v-bind:class="{ 'validation -invalid': validation.city }"
                    />
                    <div
                      v-if="validation.city"
                      v-on:click="setfocus('city')"
                      class="error-message"
                    >
                      {{ validation.city[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>State/Province</label>
                    <select
                      v-model="fields.state"
                      ref="state"
                      v-on:change="
                        validation.state && (validation.state[0] = null)
                      "
                    >
                      <option disabled="disabled" value="">Select one</option>
                      <option v-for="state in states">{{ state }}</option>
                    </select>
                    <div v-if="validation.state" class="-validation">
                      {{ validation.state[0] }}
                    </div>
                  </div>
                  <div class="group">
                    <label>Zip/Postal Code</label>
                    <input
                      type="text"
                      v-bind:placeholder="
                        country === 'US' ? '92103' : 'M4B 1B3'
                      "
                      ref="postal"
                      v-model="fields.postal"
                      v-bind:class="{
                        short: true,
                        'validation -invalid': validation.postal,
                      }"
                    />
                    <div
                      v-if="validation.postal"
                      v-on:click="setfocus('postal')"
                      class="error-message short"
                    >
                      {{ validation.postal[0] }}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div v-if="!status.complete" style="position: relative">
                  <button
                    type="submit"
                    class="ctaButton cta-pill filled-red icon right-arrow mr-4"
                    :disabled="status.idle"
                  >
                    Submit
                  </button>
                  <a
                    href="#"
                    v-on:click.prevent="active = false"
                    class="ctaButton cta-plain text-black icon right-arrow"
                    >Cancel</a
                  >
                </div>

                <div class="response">
                  <div v-if="status.idle" class="spinner"></div>
                  <div
                    class="type"
                    v-bind:class="{ [`-${response.type}`]: response.type }"
                  >
                    <h3
                      style="margin: 1rem 0 0 0"
                      v-if="
                        response.type === 'confirmation' ||
                        response.type === 'error'
                      "
                    >
                      {{ response.message }}
                    </h3>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="backdrop"><!-- backdrop --></div>
  </div>
</template>

<script>
import recaptcha from "../../mixins/recaptcha";

let fillable = {
  recaptcha: "",
  honey: "",
  origin: location.href,
  firstname: "",
  lastname: "",
  email: "",
  account: "",
  company: "",
  storetype: "n/a",
  business: "",
  address: "",
  city: "",
  state: "",
  postal: "",
};

export default {
  name: "modal-b9a1af4d",
  mixins: [recaptcha],
  data() {
    return {
      active: false,
      status: {
        idle: null,
        complete: false,
      },
      response: {
        type: "", // validation or confirmation
        message: "", // response
      },
      country: undefined,
      fields: { ...fillable },
      validation: {},
    };
  },
  watch: {
    active(val) {
      document.body.style["overflow"] = val ? "hidden" : "visible";

      if (val) {
        this.recaptcha();
      }
    },
  },
  computed: {
    states() {
      let provinces = [
        "Alberta",
        "British Columbia",
        "Manitoba",
        "New Brunswick",
        "Newfoundland and Labrador",
        "Nova Scotia",
        "Ontario",
        "Prince Edward Island",
        "Quebec",
        "Saskatchewan",
        "Northwest Territories",
        "Nunavut",
        "Yukon",
      ];

      let states = [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District Of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
        "American Samoa",
        "Guam",
        "Northern Mariana Islands",
        "Puerto Rico",
        "United States Minor Outlying Islands",
        "Virgin Islands",
        "Armed Forces Americas",
        "Armed Forces Pacific",
        "Armed Forces Others",
      ];

      return this.country === "US" ? states : provinces;
    },
  },
  methods: {
    reset() {
      return (this.fields = {
        ...fillable,
      });
    },
    setfocus(arg) {
      this.validation[arg] = null;
      this.$refs[arg].focus();
    },
    submit(event) {
      let data = new FormData();

      for (let prop in this.fields) {
        data.append(prop, this.fields[prop]);
      }

      // on before send
      axios.interceptors.request.use((config) => {
        this.status.idle = true;
        this.response.message = "";
        this.validation = {};

        return config;
      });

      axios({
        method: "post",
        url: "/wp-json/resmed/v1/get-listed",
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
        data: data,
      }).then((response) => {
        let data = response.data;

        this.status.idle = null;

        if ("validation" in data) {
          this.response.type = "validation";
          this.validation = data.validation;
        }

        if ("confirmation" in data) {
          this.response.type = "confirmation";
          this.response.message = data.confirmation;
        }

        if ("error" in data) {
          this.response.type = "error";
          this.response.message = data.error;
        }

        if ("confirmation" in data || "error" in data) {
          this.status.complete = true;
          this.reset(); // reset all form fields
        }
      });
    },
    // recaptcha() {
    //     $.getScript("https://www.google.com/recaptcha/api.js?onload=callback", () => {
    //         window.callback = function() {
    //             grecaptcha.execute();
    //         };

    //         window.recaptcha = (arg) => {
    //             this.fields.recaptcha = arg;
    //         };
    //     });
    // }
  },
  created() {
    this.$parent.$on("getlisted:active", (arg) => {
      this.active = arg;
    });

    this.country = /canada-/.test(location.pathname) ? "CA" : "US";
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/modal";

.overlay {
  .item {
    background-color: #f2f9ff;
    background-image: url(#{$assets}/images/join-community-bg@3x.png);
    background-repeat: no-repeat;
    background-size: 450px;
    background-position: 0 -30px;
    border-radius: 6px;
  }

  .layout {
    position: relative;
    margin: 6rem auto 0 auto;
    width: 960px;
    max-width: 90vw;
    box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.75);

    @media (min-height: 800px) {
      margin: 12rem auto 0 auto;
    }
  }

  .wrapper {
    padding: 4rem 1.5rem;

    @media (min-width: 768px) {
      padding: 4rem;
    }

    @media (min-width: 992px) {
      padding: 6rem 6rem 4rem 6rem;
    }

    h2 {
      position: relative;
      margin-bottom: 1rem;
      @extend %eyebrow-left;
    }

    form {
      > :last-child {
        padding-top: 2rem;
        margin-top: 2rem;
        border-top: 1px solid #ccc;
      }

      select {
        background-color: #dde8f6;
      }

      .honey-pot {
        display: none;
      }

      .short {
        @media (min-width: 768px) {
          max-width: 60%;
        }
      }

      .spinner {
        margin: 0 auto;
        border-left-color: $cc-resmed-action-red;
      }

      .error-message {
        cursor: text;
        border: 2px solid #dd2726;
        background-color: $cc-resmed-white;
        position: relative;
        border-radius: 6px;
      }

      .-invalid {
        border: none;
      }

      .-validation {
        @extend %body-small-bold;
        text-align: right;
      }
    }
  }
}
</style>